import React from 'react';
import { Box, Checkbox, FormControl, FormControlLabel } from '@mui/material';

interface Props {
    hasAgreed: boolean;
    onChange: () => void;
    disabled?: boolean;
}

export default function CoachSMSCheckbox({ hasAgreed, onChange, disabled }: Props) {
    return (
        <Box className="terms-checkbox-container" sx={{ mb: 2 }}>
            <FormControl>
                <FormControlLabel
                    disabled={disabled}
                    control={<Checkbox checked={hasAgreed} onChange={onChange} />}
                    label={
                        <Box className="terms-container narrow">
                            By checking this box, you agree to receive TrainHeroic account updates and setup tips.
                            Msg & data rates may apply. Freq varies. Text HELP for help, STOP to cancel.
                        </Box>
                    }
                />
            </FormControl>
        </Box>
    );
}
